import { ConfigValidationError } from "../../../../../../types";
import { ComponentConfigState } from "../../../../types";
import selectVisibilityRuleErrors from "../../common/VisibilityRulesManager/selectErrors";

export default function errorSelector(
  state: ComponentConfigState
): ConfigValidationError[] {
  const { draftComponent } = state;
  let errors: ConfigValidationError[] = [];

  if (!draftComponent.properties.template) {
    errors.push({
      field: "TEMPLATE",
      message: "Please provide a template for this calculated field."
    });
  }

  errors = errors.concat(selectVisibilityRuleErrors(draftComponent));
  return errors;
}
